<template>
<div>
    <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="考证名称">
            <el-input class="inputItem" v-model="form.trName"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
            <el-input class="inputItem" v-model="form.trUrl"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
            <el-upload list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" accept=".jpg,.jpeg,.png" :action="fileUploads.actionUrl" :headers="fileUploads.authToken" :before-upload="beforeUploadEvidenceMenu" :on-success="sendEvidenceMenu" :file-list="bannerfile">
                <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body='false' title="封面预览" :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit" round>提交</el-button>
            <el-button @click="canel" round>取消</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
export default {
     props: {
        kzRowInfo: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                trId: '',
                trName: '',
                trUrl: ''
            },
            bannerfile: [],
            dialogImageUrl: '',
            dialogVisible: false,
            fileUploads: {
                actionUrl: process.env.VUE_APP_BASE_API + '/api/file/upload',
                authToken: {
                    JWTToken: sessionStorage.getItem('token'),
                    ctype: 'PC'
                }
            },
            editState: false
        }
    },
    methods: {
        beforeUploadEvidenceMenu(file) {
            console.log(file)
            if (['image/png', 'image/jpg', 'image/jpeg'].every(item => item != file.type)) {
                this.$message.error('仅支持png、jpg、jpeg格式的文件!');
                return false
            }
            const isLt = file.size / 1024 / 1024 < 10;
            if (!isLt) {
                this.$message.error('上传图片不能超过10M');
                return false
            }
            if (this.bannerfile.length == 1) {
                this.$message.error('一节课程只允许上传一个课程封面');
                return false
            }
        },
        sendEvidenceMenu(response, file, fileList) {
            console.log('----上传文件----', response, file)
            if (this.bannerfile.length > 1) {
                this.$message.error('一节课程只允许上传一个课程封面');
                return false
            }
            this.bannerfile.push({
                url: response.data,
                name: file.name
            })
        },
        onSubmit() {
            if (this.form.trName.toString().trim() == "") {
                this.$message.warning('请输入考证课程名称')
                return
            }
            if (this.form.trUrl.toString().trim() == "") {
                this.$message.warning('请输入考证课程地址')
                return
            }
            if (this.bannerfile.length == 0) {
                this.$message.warning('请上传直播封面图片')
                return
            }
            let that = this
            let params = {
                trName: this.form.trName,
                trUrl: this.form.trUrl,
                coverUrl: this.bannerfile.length > 0 ? this.bannerfile[0].url : this.form.coverUrl
            }
            if (this.form.trId) {
                params.trId = this.form.trId
                this.$api.updateKZList(params).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message.success('保存成功')
                        this.$emit('closeDialog')
                    } else {
                        this.$message.error('保存失败')
                    }
                })
            } else {
                this.$api.addKZList(params).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message.success('保存成功')
                        this.$emit('closeDialog')
                    } else {
                        this.$message.error('保存失败')
                    }
                })
            }
        },
        handleRemove(file) {
            console.log(file);
            this.bannerfile = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        initKZData() {
            if (this.kzRowInfo) {
                this.form.trId = this.kzRowInfo.trId
                this.form.trName = this.kzRowInfo.trName
                this.form.trUrl = this.kzRowInfo.trUrl
                this.bannerfile.push({
                    url: this.kzRowInfo.coverUrl,
                    name: '封面图'
                })
            }
        },
        canel(){
            this.$emit('closeDialog')
        }
    }
}
</script>

<style>
.inputItem {
    width: 360px !important;
}
</style>
